var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 5.33329V4.66663M5.33337 8.33329V7.66663M5.33337 11.3333V10.6666M4.53337 13.3333H11.4667C12.5868 13.3333 13.1469 13.3333 13.5747 13.1153C13.951 12.9236 14.257 12.6176 14.4487 12.2413C14.6667 11.8134 14.6667 11.2534 14.6667 10.1333V5.86663C14.6667 4.74652 14.6667 4.18647 14.4487 3.75864C14.257 3.38232 13.951 3.07636 13.5747 2.88461C13.1469 2.66663 12.5868 2.66663 11.4667 2.66663H4.53337C3.41327 2.66663 2.85322 2.66663 2.42539 2.88461C2.04907 3.07636 1.74311 3.38232 1.55136 3.75864C1.33337 4.18647 1.33337 4.74652 1.33337 5.86663V10.1333C1.33337 11.2534 1.33337 11.8134 1.55136 12.2413C1.74311 12.6176 2.04907 12.9236 2.42539 13.1153C2.85322 13.3333 3.41327 13.3333 4.53337 13.3333Z",
    stroke: "#475467",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket02);
export default __webpack_public_path__ + "static/media/ticket-02.3de4536590a94b1f3c5090eb77ac84bc.svg";
export { ForwardRef as ReactComponent };